<template>
  <div class="minheight100 bg-grey" style="padding-bottom:233px">
    <div class="imgmax" style="text-align:center">
      <img src="https://img-cdn1.ylyk.com/image/1686135547559_m1686135506414_s2462912.jpg" />
    </div>
    <div class="fixed-bottom">
      <div class="title">
        添加班主任，获取
        <span class="red">订金名额</span>
      </div>
      <div class="adviser">
        <div class="img">
          <img :src="detail.adviserAvatar" />
        </div>
        <div class="name">{{ detail.adviserName }}</div>
      </div>
      <div class="btn-common" @click="addAdviser">
        立即添加
      </div>
    </div>
  </div>
</template>
<script>
import Body from '@/mixins/body'
import { appUser } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import activityService from '@/api/modules/payment/activity'
import goWeixin from '@/utils/goWeixin'
const action = 'earnestMoney'

export default {
  components: {},
  data() {
    return {
      id: '',
      detail: {}
    }
  },
  mixins: [Body],
  computed: {},
  watch: {},
  created() {
    this.id = this.$route.query.id || 3
    // // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.getData()
    },
    getData() {
      activityService.getAdviserDetail({ configId: this.id }).then(res => {
        console.log(res)
        this.detail = res
      })
    },
    addAdviser() {
      goWeixin(4, this.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.fixed-bottom {
  .title {
    text-align: center;
    font-weight: bold;
    .red {
      color: rgba(255, 0, 0, 1);
    }
  }
  .adviser {
    text-align: center;
    margin: 16px 0;
    .img {
      border-radius: 50%;
      display: inline-block;
      width: 72px;
      height: 72px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-size: 12px;
      margin-top: 6px;
      color: #999;
    }
  }
}
</style>
